import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonTapDirective } from 'core/directives/button-tap.directive';

import { OnInitDirective } from '../../directives/on-init.directive';
import { IconsModule } from '../icons/icons.module';
import { AccordionComponent } from './accordion.component';
import { AccordionItemComponent } from './accordion-item/accordion-item.component';

@NgModule({
  declarations: [AccordionComponent, AccordionItemComponent],
  imports: [CommonModule, OnInitDirective, ButtonTapDirective, IconsModule],
  exports: [AccordionComponent, AccordionItemComponent],
})
export class AccordionModule {}
